import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { SolicitacaoForm } from "../../modais"

class NotificacaoEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/solicitacaoesclarecimento")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <SolicitacaoForm
          isEditing={true}
          callBackSolicitacao={this.onSuccess}
        />
      </Layout>
    )
  }
}
export default withRouter(NotificacaoEditForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/notificacao/NotificacaoEditForm.js